export default __webpack_public_path__ + "static/media/fechadura-pressao-porta-pivotante.746f40b4.png";